import React from 'react';
import CustomButton from '../ui/Button';
import { useTranslation } from "react-i18next";



const EmpowerSection = () => {
    const { t,i18n } = useTranslation("home"); // Hook to use translations
    const isRussian = i18n.language === "ru"; // Check if the language is Russian

    return (
        <div className="relative mx-auto px-[30px] max-w-[1220px] flex flex-col md:flex-row items-center mt-[53px] mb-[70.45px]">
            <div className="flex flex-col md:flex-row-reverse items-center w-full">
                {/* <div style={{
                        position: 'absolute',
                        right: '-13rem',
                        top: '-8rem',
                    }}>
                        <img src="/assets/ellipse.svg" alt="Ellipse" className="w-81" />
                    </div> */}
                {/* Right Section with Card */}
                <div className="w-full md:w-1/2 mb-8 md:mb-0 h-[581px] md:pl-16">





                    <div className="relative rounded-xl overflow-hidden shadow-lg h-full">
                        <img
                            src="/assets/empower.png"
                            alt="Safety Work Environment"
                            className="w-[514px] h-[581px] object-cover transition-transform duration-[1500ms] ease-in-out transform hover:scale-125"
                        />
                    </div>

                </div>

                {/* Left Section with Text */}
                <div className="w-full md:w-1/2 text-white flex flex-col justify-center">
                    <div className="title-small gradient-text font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit">

                        {t("boost_workforce_efficiency")}

                    </div>
                    <div className='max-w-[540px]'>
                        
                    <h2 className={`web-heading-card-4 text-color-2 tracking-[-1.2px] mb-4 ${isRussian ? 'lang-ru-web-heading-card-4' : ''}`}>
                        {t("empower_team_performance")}

                    </h2>
                    <p className="body-large-2 text-color mb-4">

                        {t("tauken_monitoring_tools")}
                    </p>
                    </div>
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="flex-1 max-w-[255px]">
                            <h3 className="title-medium-2 text-color-2 mb-2">
                                {t("boost_workforce_efficiency")}
                            </h3>
                            <p className="body-medium-3 text-color mb-4">

                                {t("empower_team_performance")}

                            </p>
                        </div>
                        <div className="flex-1">
                            <div className='max-w-[301px]'>
                                <h3 className="title-medium-2 text-color-2 mb-4 ">
                                    {t("empower_data_performance")}
                                </h3>
                            </div>
                            <div className='max-w-[254px]'>
                                <p className="body-medium-3 text-color mb-4">

                                    {t("leverage_real_time_data")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <a href="/services">
                        <CustomButton className='w-fit' href="/services">
                            {t("explore_productivity_tools")}</CustomButton>

                    </a>
                </div>
            </div>
        </div>
    );
};

export default EmpowerSection;